import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../../common/ModalTrigger';
import EmployerSignupForm from '../EmployerSignupForm';
import { analyticsTrack } from '../../../analyticsUtils';
import './Wall.scss';
var Wall = /*#__PURE__*/function (_Component) {
  function Wall(props) {
    var _this;
    _classCallCheck(this, Wall);
    _this = _callSuper(this, Wall, [props]);
    _this.state = {};
    _this.handleEventsTracking = _this.handleEventsTracking.bind(_this);
    return _this;
  }
  _inherits(Wall, _Component);
  return _createClass(Wall, [{
    key: "handleEventsTracking",
    value: function handleEventsTracking() {
      var location = this.props.location;
      analyticsTrack('Clicked on get started', {
        location: location
      });
      analyticsTrack('Opened registration modal', {
        location: location
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        signInUrl = _this$props.signInUrl,
        googleOmniauthUrl = _this$props.googleOmniauthUrl,
        msOmniauthUrl = _this$props.msOmniauthUrl,
        consultantFirstName = _this$props.consultantFirstName,
        location = _this$props.location,
        inviterId = _this$props.inviterId,
        projectResourceId = _this$props.projectResourceId;
      return [/*#__PURE__*/React.createElement("div", {
        className: "blur-text"
      }), /*#__PURE__*/React.createElement("div", {
        className: "registration-wall"
      }, /*#__PURE__*/React.createElement("h3", null, "Ready to review ".concat(consultantFirstName, "\u2019s full proposal & hourly rate?")), /*#__PURE__*/React.createElement("div", {
        className: "cta-row d-flex justify-content-center"
      }, /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Get Started",
        buttonStyles: "primary",
        dialogClassName: "style-guide registration-modal",
        closeAfterSubmit: true,
        idKey: "employer-registration-modal",
        showFooter: false,
        onClick: this.handleEventsTracking
      }, /*#__PURE__*/React.createElement("div", {
        className: "employer-registration-modal"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "hero-header"
      }, "Switch to the simplest way of hiring"), /*#__PURE__*/React.createElement(EmployerSignupForm, {
        csrfToken: csrfToken,
        submitButtonText: "Sign Up",
        pageLocation: "proposal",
        signInUrl: signInUrl,
        googleOmniauthUrl: googleOmniauthUrl,
        msOmniauthUrl: msOmniauthUrl,
        location: location,
        inviterId: inviterId,
        projectResourceId: projectResourceId
      }))), /*#__PURE__*/React.createElement("div", null, "Already have a Clora account?", /*#__PURE__*/React.createElement("a", {
        href: signInUrl,
        className: "login-link text-decoration-none m-0 px-2 fs-6 fw-semibold"
      }, "Log In Here."))))];
    }
  }]);
}(Component);
Wall.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  consultantFirstName: PropTypes.string.isRequired,
  location: PropTypes.string,
  inviterId: PropTypes.string,
  projectResourceId: PropTypes.string
};
Wall.defaultProps = {
  location: 'Proposal share - employers',
  inviterId: null,
  projectResourceId: null
};
export default Wall;